import { scrollPageTo } from '../utils';

export default class ScrollPageToButton {

    static init(e) {
        const buttons = e.detail.element.querySelectorAll('[data-scroll-page-to-button]');
        buttons.forEach((el) => new this(el));

        const hash =  window.location.hash;
        if(hash) {
            const target = e.detail.element.querySelector(hash);
            if(target) {
                setTimeout(() => {
                    scrollPageTo(target, 1500, 0);
                }, 1000);
            }
        }
    }

    constructor(el) {
        this.el = el;
		const target = this.el.getAttribute('href');

        this.el.addEventListener('click', e => {
            e.preventDefault();
            scrollPageTo(target, 1500, 0);
        });

    }
}
